import { SxProps, Theme } from '@mui/material';

export const sloganContactBoxIconsGridContainerStylesSx: SxProps<Theme> = (theme) => ({
	display: 'flex',
	borderTop: '3px solid #f96302',
	width: '100%',
	[theme.breakpoints.down('md')]: {
		flexDirection: 'column',
	},
	[theme.breakpoints.up('md')]: {
		padding: '15px',
	},
});
